// extracted by mini-css-extract-plugin
export default {"head":"jBEqEx","body":"ylJB2t","xs":"YVlTFU","hero":"qK1SMh","lg":"lbtVKx","xl":"u0tR6o","video-wrapper":"nggUhJ","videoWrapper":"nggUhJ"};